import React, { useCallback } from 'react';
import moment from 'moment';
import { makeStyles } from '@material-ui/core/styles';
//import { Container, Grid } from '@material-ui/core';
import { fade } from '@material-ui/core/styles/colorManipulator';

import useDiaryData from '../../hooks/useDiaryData';

import Calendar from './Calendar';

const periodFormat = 'YYYY-MM';

const useStyles = makeStyles(theme => ({
	root: {
		position: 'sticky',
		top: theme.mixins.toolbar.minHeight,
		zIndex: 1,
		backgroundColor: 'white',
	},
	highlight: {
		backgroundColor: fade(theme.palette.primary.light, 0.2),
	}
}));

function CalendarSection() {
	const classes = useStyles();

	// eslint-disable-next-line
	const [data, status, handleSetSelectedDate] = useDiaryData();

	const handleDateClick = useCallback((newValue) => {
		if(newValue) handleSetSelectedDate(newValue);
	}, [handleSetSelectedDate]);

	const datesWithData =  data.data.map(e => e.date);

	const isDayHighlighted = (currentDate) => {
		return datesWithData.includes(currentDate);
	};

	return (
		<div className={classes.root}>
			<Calendar
				highlightClassName={classes.highlight}
				isDayHighlighted={isDayHighlighted}
				date={data.selectedDate}
				period={moment(data.selectedDate).format(periodFormat)}
				onDateClick={handleDateClick}
			/>
		</div>
	);
}

export default CalendarSection;
